import SearchCustomerBox from '@/components/calendar/SearchCustomer';
import { CustomerDto } from '@/models/club';
import useGetCustomers from '@/pages/dashboard/customer/hooks/useGetCustomers';
import React, { useState } from 'react'
import CustomerItem from '../schedule/customer/customerItem';
import { Stack } from '@mantine/core';
import ListItemLoading from '@/components/loading/listItemLoading/listItemLoading';


type Props = {
    setSelectedCustomer: (e: CustomerDto | null) => void;
    close: () => void;
}

function SearchCustomer({ setSelectedCustomer, close }: Props) {

    const [search, setSearch] = useState("");

    const { data, isLoading } = useGetCustomers({
        term: search,
        count: 100,
        skip: 0,
        enabled: true,
    });

    return (
        <>
            <SearchCustomerBox setSearch={setSearch} />
            <Stack>
                {isLoading && <ListItemLoading count={3} />}
                {data?.pages.map((page, pageIndex) => (
                    <React.Fragment key={pageIndex}>
                        {page?.result?.map((customer, customerIndex) =>
                            page?.result?.length === customerIndex + 1 ? (
                                <div>
                                    <CustomerItem
                                        key={customer?.id}
                                        customer={customer}
                                        setSelectedCustomer={() => { setSelectedCustomer(customer); close(); }}
                                    />
                                </div>
                            ) : (
                                <CustomerItem
                                    key={customer?.id}
                                    customer={customer}
                                    setSelectedCustomer={() => { setSelectedCustomer(customer); close(); }}
                                />
                            )
                        )}
                    </React.Fragment>
                ))}
            </Stack>
        </>

    )
}

export default SearchCustomer